<template>
  <footer class="app-footer">
    <div class="container text-center py-3">
      <small class="text-muted">
        Unauthorized Access Prohibited<br>
        All Access Logged
      </small>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.app-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: transparent;
  font-size: 0.75rem;
  opacity: 0.6;
}

/* Dark mode */
#app.dark-mode .app-footer .text-muted {
  color: #9ca3af !important;
}
</style>
